import { Button, Form, Input } from "antd";
import { useGetBreakpoints } from "../hooks/useGetBreakpoints";
import SidebarLogo from "./Sidebar/SidebarLogo";
import { Link } from "react-router-dom";
import { useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { LoginWithVerifyEmailOTP } from "../appRedux/actions";
import { labelComponent } from "../util/UtilComponents";
import { showAlert } from "../util/helper";
import { useEffect } from "react";

const FormItem = Form.Item;
const LoginWithEmailOtp = () => {
  const [form] = Form.useForm();
  const { isMobile } = useGetBreakpoints();
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(({ common }) => common.loading);
  const otpError = useSelector(({ auth }) => auth.otpError);
  
  // Clear OTP field when error occurs so user can easily re-enter
  useEffect(() => {
    if (otpError) {
      form.setFieldsValue({ otp: "" });
    }
  }, [otpError, form]);
  
  const onFinishFailed = (errorInfo) => {};
  const email = location?.state?.email;
  const onFinish = (values) => {
    const emailToUse = values?.email || email;
    if (!emailToUse) {
      showAlert("Please enter an email", "error");
      return;
    }
    console.log('test otp onclick event works line 26');
    dispatch(LoginWithVerifyEmailOTP(values?.otp, emailToUse));
    console.log('test otp onclick event works line 28');
  };
  const handleClick = () => {
    console.log(" Back to signin clicked");
    history.push("/signin");
  };
  return (
    <>
      <div
        style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
      >
        <div
          style={{
            backgroundColor: "white",
            zIndex: 1,
            position: "relative",
          }}
        >
          <SidebarLogo />
        </div>
        <div
          className="gx-login-container"
          style={{
            backgroundImage: "url(/assets/images/Login_Page_BG_Image.png)",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            flex: 1,
            display: "flex",
            alignItems: "right",
            justifyContent: "right",
            position: "relative",
            paddingRight: !isMobile ? "100px" : "0px",
          }}
        >
          <div>
            <div
              className="gx-login-content"
              style={{
                marginTop: "80px",
                minHeight: "500px",
              }}
            >
              <div className="gx-mb-4">
                <div className="gx-login-header">Welcome Back</div>
                <p className="gx-login-description">
                  Don't have an account? &nbsp;{" "}
                  <Link className="myexim-link" to="/signup">
                    Register
                  </Link>
                </p>
              </div>
              <Form
                form={form}
                initialValues={{ email }}
                name="basic"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
              >
                <FormItem
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  label={labelComponent("Email ", null)}
                  rules={[
                    { required: true, message: "Please input your E-mail!" },
                  ]}
                  name="email"
                >
                  <Input
                    size="large"
                    readOnly
                  />
                </FormItem>

                <FormItem
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  label={labelComponent("OTP", null)}
                  rules={[
                    { required: true, message: "Please input your otp!" },
                  ]}
                  name="otp"
                >
                  <Input size="large" maxLength={4} placeholder="OTP" autoFocus />
                </FormItem>

                <FormItem
                  className="gx-text-center"
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                >
                  <Button
                    type="primary"
                    size="large"
                    htmlType="submit"
                    block
                    loading={loading}
                  >
                    Login
                  </Button>
                  <Button
                    onClick={handleClick}
                    type="secondary"
                    size="large"
                    block
                  >
                    Back
                  </Button>
                </FormItem>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginWithEmailOtp;
